import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, filter, map, mergeMap, takeUntil } from 'rxjs/operators'

import { URL_CONST } from 'utils/urlConsts'
import { matchURL } from 'utils/urls'

import { FETCH_SELECTED_COMPANY_DATA_ASYNC } from '../../PartnerOptions/constants'

import {
  copyLandingPageError,
  copyLandingPageSuccess,
  deleteLandingPageError,
  deleteLandingPageSuccess,
  fetchLandingPagesError,
  fetchLandingPagesSuccess,
} from './actions'
import {
  COPY_LANDING_PAGE_ASYNC,
  DELETE_LANDING_PAGE_ASYNC,
  LANDING_PAGES_REQUEST_ASYNC,
  PAGINATE_CHANGE,
  SEARCH_CHANGE,
} from './constants'

const fetchLandingPagesEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(
      LANDING_PAGES_REQUEST_ASYNC.INITIATE,
      PAGINATE_CHANGE,
      SEARCH_CHANGE,
      FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS,
      DELETE_LANDING_PAGE_ASYNC.SUCCESS,
      COPY_LANDING_PAGE_ASYNC.SUCCESS
    ),
    filter((action) => {
      if (action.type === FETCH_SELECTED_COMPANY_DATA_ASYNC.SUCCESS)
        return matchURL(URL_CONST.awarenessCenter.landingpage)
      return true
    }),
    mergeMap(() =>
      api.awarenessCenter
        .fetchLandingPages(
          state$.value.awarenessCenter.landingPages.page || 1,
          state$.value.awarenessCenter.landingPages.search,
          state$.value.partnerOptions.selectedCompany?.value,
          !!state$.value.app.data.partner
        )
        .pipe(
          mergeMap((response) => of(fetchLandingPagesSuccess(response))),
          catchError((error) => of(epicsErrorHandler(fetchLandingPagesError, error))),
          takeUntil(action$.pipe(ofType(LANDING_PAGES_REQUEST_ASYNC.CANCEL)))
        )
    )
  )

const deleteLandingPageEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(DELETE_LANDING_PAGE_ASYNC.INITIATE),
    mergeMap((action) =>
      api.awarenessCenter.deleteLandingPage(action.payload.id).pipe(
        map((response) => deleteLandingPageSuccess(response)),
        catchError((error) => of(epicsErrorHandler(deleteLandingPageError, error))),
        takeUntil(action$.pipe(ofType(DELETE_LANDING_PAGE_ASYNC.CANCEL)))
      )
    )
  )

const copyLandingPageEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(COPY_LANDING_PAGE_ASYNC.INITIATE),
    mergeMap((action) =>
      api.awarenessCenter.copyLandingPage(action.payload.id, action.payload.companiesIds).pipe(
        map((response) => copyLandingPageSuccess(response)),
        catchError((error) => of(epicsErrorHandler(copyLandingPageError, error))),
        takeUntil(action$.pipe(ofType(COPY_LANDING_PAGE_ASYNC.CANCEL)))
      )
    )
  )

export default combineEpics(fetchLandingPagesEpic, deleteLandingPageEpic, copyLandingPageEpic)
